import React from 'react';
import PropTypes from 'prop-types';

import Date from "components/Display/ViewDate";
import YesNo from "components/Display/YesNo";
import Amount from "components/Display/Amount";
import Percentage from "components/Display/Percentage";


const CapitalInfo = ({ data, setting }) => {

  let isBond = (setting.isBond && (setting.legs != null));  
  if (!isBond){
    return (
      <div/>
    );
  }

  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }  

  console.debug("the data", data);
  let leg = setting.legs[0];
  let bond = setting.bond;
  
  
  let isIndexed = setting.isBond && (setting.legs != null) && (setting.legs[0].indexInterestDate != null) && (setting.legs[0].indexTable != null);
  let isEqualization = setting.isBond && (setting.legs != null) && (setting.legs[0].indexInterestDate != null) && (setting.legs[0].indexTable != null) && (setting.legs[0].isEqualization);
  
  let calledInContent;
  if (leg.calledInBecauseOfDefault){
    calledInContent = (
      <span> vegna vanskil. </span>
    );
  }

//Greiðslujöfnun data
let GeneralData = (
  <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="2" className="text-left calc-setting-table-header">Forsendur</th>
        </tr>
        </thead>
        <tbody>
          <tr>
            <th className="text-right">Fjöldi afborgana</th>
            <td className="text-right">{leg.numberOfPayments}</td>
          </tr>
          <tr>
            <th className="text-right">Fjöldi vaxtaborgana</th>
            <td className="text-right">{leg.numberOfInterestPayments}</td>
          </tr>
          <tr>
            <th className="text-right">Mánuðir milli gjalddaga</th>
            <td className="text-right">{leg.monthsBetweenPayments}</td>
          </tr>

          <tr>
            <th className="text-right">Útgáfudagur</th>
            <td className="text-right"><Date data={leg.issueDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Fyrsti gjalddagi</th>
            <td className="text-right"><Date data={leg.firstPaymentDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Fyrstu vanskil</th>
            <td className="text-right"><Date data={bond.firstNeglectPaymentDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Samningsvaxtadagur</th>
            <td className="text-right"><Date data={leg.contractInterestDate}/></td>
          </tr>
          
          {leg.calledIn &&
          <tr>
            <th className="text-right">Gjaldfellt</th>
            <td className="text-right"><YesNo data={leg.calledIn}/>
              {calledInContent}</td>
          </tr>}
          {leg.calledIn && <tr>
            <th className="text-right">Gjaldfellingardagur</th>
            <td className="text-right"><Date data={leg.calledInDate}/></td>
          </tr>}          
        </tbody>
      </table>
  </div>
);

//Verðtrygging data
let IndexData = (
  <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="2" className="text-left calc-setting-table-header">Verðtrygging</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <th className="text-right">Verðtrygginardagur</th>
            <td className="text-right"><Date data={leg.indexInterestDate}/></td>
        </tr>
        <tr>
            <th className="text-right">Grunnvísitala</th>
            <td className="text-right"><Amount data={data.bond.legs[0].statistics.indexBasePoint} precision={1}/></td>
        </tr>                    
        <tr>
          <th className="text-right">Framtíðarverðbólga á ári</th>
          <td className="text-right"><Percentage data={leg.futureIndexRate}/></td>
        </tr>                      
        </tbody>
      </table>
  </div>
);

  //Greiðslujöfnun data
  let EqualizationData = (
    <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left calc-setting-table-header">Greiðslujöfnun</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th className="text-right">Grunngreiðslumark</th>
            <td className="text-right"><Amount data={data.bond.legs[0].statistics.equalizationBaseLimit}/></td>
          </tr>
          <tr>
            <th className="text-right">Viðmiðuardagsetning</th>
            <td className="text-right"><Date data={data.bond.legs[0].statistics.equalizationBaseDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Grunn GJV</th>
            <td className="text-right"><Amount data={data.bond.legs[0].statistics.equalizationBasePoint} precision={1}/></td>
          </tr>            
          <tr>
            <th className="text-right">Framtíðarbreyting á GJV á ári</th>
            <td className="text-right"><Percentage data={leg.futureEqualizationRate}/></td>
          </tr>                      
          </tbody>
        </table>
    </div>
  );

  return (
    <div className="grid tight">
      <div className="col s2of12">  
        {GeneralData}
      </div>
      <div className="col s2of12">  
        {isIndexed && IndexData}
      </div>      
      <div className="col s2of12">  
        {isEqualization && EqualizationData}
      </div>
    </div>      
  );
};

CapitalInfo.propTypes = {
  data: PropTypes.object,
  setting: PropTypes.object
};

export default CapitalInfo;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/CapitalInfo.js